<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CONVÊNIO -
                            <strong
                                >{{ convenio.vcCodigoEstruturado }} -
                                {{
                                    convenio.convenente
                                        ? convenio.convenente
                                        : ''
                                }}</strong
                            >
                            <b-badge variant="warning" class="ml-2">{{
                                operacao
                            }}</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>

                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Cadastrais" active class="pb-0">
                                <Convenio-Dados-Cadastrais
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                ></Convenio-Dados-Cadastrais>
                            </b-tab>
                            <b-tab title="Aditivos" class="pb-0">
                                <Convenio-Aditivos
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                ></Convenio-Aditivos>
                            </b-tab>
                            <b-tab title="Ações" class="pb-0">
                                <Convenio-Acoes
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                ></Convenio-Acoes>
                            </b-tab>
                            <b-tab title="Aplicação de Recursos" class="pb-0">
                                <Convenios-Aplicacao-Recursos
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                    @atualizarDadosConvenio="obterConvenio()"
                                ></Convenios-Aplicacao-Recursos>
                            </b-tab>
                            <b-tab
                                title="Cronograma de Desembolso"
                                class="pb-0"
                            >
                                <Convenio-Cronograma-Desembolso
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                    @atualizarDadosConvenio="obterConvenio()"
                                ></Convenio-Cronograma-Desembolso>
                            </b-tab>
                            <b-tab
                                title="Cronograma de Recebimento"
                                class="pb-0"
                            >
                                <Convenio-Cronograma-Recebimento
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                    @atualizarDadosConvenio="obterConvenio()"
                                ></Convenio-Cronograma-Recebimento>
                            </b-tab>
                            <b-tab title="Centros de Custos" class="pb-0">
                                <Convenio-Projeto-Acao
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                    @atualizarDadosConvenio="obterConvenio()"
                                ></Convenio-Projeto-Acao>
                            </b-tab>
                            <b-tab
                                title="Prestação de Contas Mensal"
                                class="pb-0">
                                <Convenio-Prestacao-Conta-Mensal
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                    @obterConvenio="obterConvenio()"
                                    @atualizarDadosConvenio="obterConvenio()"
                                    :exibirBotaoAdicionar="true"
                                ></Convenio-Prestacao-Conta-Mensal>
                            </b-tab>
                            <b-tab
                                title="Prestação de Contas Final"
                                class="pb-0">
                                <Convenio-Prestacao-Final
                                    v-if="$temAcessoView('CONV-00')"
                                    :convenio="convenio"
                                    @atualizarDadosConvenio="obterConvenio()"
                                ></Convenio-Prestacao-Final>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import ConvenioDadosCadastrais from './ConvenioDadosCadastrais'
import ConveniosAplicacaoRecursos from './ConvenioAplicacaoRecursos'
import ConvenioCronogramaDesembolso from './ConvenioCronogramaDesembolso'
import ConvenioCronogramaRecebimento from './ConvenioCronogramaRecebimento'
import ConvenioPrestacaoContaMensal from '../cadastro/PrestacaoContasMensal'
import ConvenioProjetoAcao from '../cadastro/Comprometimento'
import ConvenioAcoes from './ConvenioAcoes'
import ConvenioAditivos from './ConvenioAditivos'
import ConvenioPrestacaoFinal from './ConvenioPrestacaoContasFinal'

export default {
    components: {
        ConvenioDadosCadastrais,
        ConveniosAplicacaoRecursos,
        ConvenioCronogramaDesembolso,
        ConvenioCronogramaRecebimento,
        ConvenioPrestacaoContaMensal,
        ConvenioProjetoAcao,
        ConvenioAcoes,
        ConvenioAditivos,
        ConvenioPrestacaoFinal
    },

    data() {
        return {
            convenio: {},
            dadosRm: {},
            operacao: 'DETALHAR',
            tabIndex: 0,
            erros: []
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Convenios' })
        },

        obterConvenio() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.$route.params.convenioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            console.log(response)
                            this.convenio = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {
        this.obterConvenio()
    }
}
</script>
